export const MIN_CARD_WIDTH = '350px';
